import template from './PriorityRuleItemView.html';
import { PriorityRuleItemController } from './PriorityRuleItemController';
export const PriorityRuleItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: PriorityRuleItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        teams: '<',
        application: '<',
        canEditRule: '<',
        canSeeRule: '<',
        operators: '<',
        properties: '<',
        relations: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        close: '&?',
        onChangeStatus: '&?',
        elementId: '@?',
        onSave: '&?',
        onToggle: '&?',
        currentState: '<',
        onOpenPriorityRule: '&?',
        isAnyPriorityRuleOpen: '&?',
    },
};
